import Header from "../components/header";
import Footer from "../components/footer";
import { Link, useParams } from "react-router-dom";
import { useRef } from "react";

const Landing = () => {
    const {duid} = useParams();
    const btn = useRef();
    const downloadfile = () => {
        btn.current.innerHTML = "downloading, please wait...";
        fetch('https://api.voicecoach.net/ck/'+duid).then(res => {if (!res.ok) {
            window.location.href = "/";
        } else {
            window.location.href = "https://api.voicecoach.net/ck/dl/"+duid;
            btn.current.innerHTML = "Downloaded... redirecting";
            setTimeout(() => window.location.href = '/', 1000);
        }});
    }
    return <>
<Header />
<main className="container">
<section className="my-5">
        <div className="row">
        <div className="col-12 text-center my-3">Your one-time download link is ready.</div>
        <div className="col-md-4 col-12 mx-auto">
            <button className="btn btn-primary w-100" ref={btn} onClick={downloadfile}>Click here to Download your eBook</button>
        </div>
    </div>
    <div className="row">
        <div className="col-12 col-xl-8 mx-auto my-3">
<h2 style={{fontSize: '3.5rem'}}>Need more than an e-Book?</h2>
<div className="row my-3">
    <div className="col-xl-8 col-12 mx-auto">
        <img src="/img/course.png" alt="do in-person course" className="w-100" />
    </div>
</div>
<p>Whoa! Look no further!</p>
<p>
Our <b>in-person and zoom courses</b> are designed with a hands-on approach, combining <b>theoretical knowledge</b> with <b>practical exercises</b> and assignments.</p>
<p>You will have the opportunity to <b>engage with industry professionals</b>, connect with fellow podcasters, and receive personalized feedback on your progress.</p>
<p>With our <b>interactive teaching</b>, you can ask questions, participate in discussions, and gain insights from real-world experiences, ensuring <b>a dynamic and engaging learning experience</b>.
</p>
<p>
<b>Key topics covered in our classes include:</b>
</p>
<ul>
<li className="my-2"><span className="text-danger fw-bold">Finding your podcasting niche:</span> Discovering the ideal subject matter and target audience for your podcast, ensuring a focused and engaging show.</li>
<li className="my-2"><span className="text-danger fw-bold">Planning and scripting:</span> Learning the art of structuring your episodes, crafting compelling narratives, and engaging your listeners through effective storytelling.</li>
<li className="my-2"><span className="text-danger fw-bold">Recording and production techniques:</span> Mastering the technical aspects of podcasting, including audio recording, editing, and enhancing sound quality.</li>
<li className="my-2"><span className="text-danger fw-bold">Podcast hosting and distribution:</span> Understanding the various podcast hosting platforms and strategies for distributing your episodes to reach a wider audience.</li>
<li className="my-2"><span className="text-danger fw-bold">Monetisation and growth strategies:</span> Exploring different methods to monetise your podcast, such as sponsorships, advertising, merchandise, and developing strategies to grow your listener base.</li>
</ul>
<p>By completing our "<b>Podcasting 101</b>" course, you will be equipped with the necessary skills and knowledge to confidently launch your podcast and showcase your unique voice to the world.</p>
<div className="row">
    <div className="col-8 mx-auto">
        <img src="/img/podpost.png" className="w-100" alt="do the course" />
    </div>
</div>
<p>Whether your goal is to <b>entertain</b>, <b>educate</b>, or <b>inspire</b>, our service empowers you to make a meaningful impact through the power of podcasting.</p>
<p>Unlock the potential of your voice! <Link to="/">Click here to find out more.</Link></p>
</div>
    </div>
</section>
</main>
<Footer />
    </>
}

export default Landing;